import React, { useEffect } from 'react';
import Breadcrumb from '../commonComponent/common/breadcrumb';
import UserAssignedLists from '../commonComponent/Usecomponent/userassignedlists';
import { useHistory } from 'react-router';
import InboundCallNotifications from '../commonComponent/Usecomponent/InboundCallNotifications';
import InCompletedcallLists from '../commonComponent/Usecomponent/InCompletedcallLists';

const Dashboard = () => {
    // console.log("Session" + localStorage.getItem('Session'));
    // let navigate = useHistory();
    // useEffect(() => {
    //     debugger;
    //     if (localStorage.getItem('Session') === null) {
    //         navigate.push('/');
    //     }
    // }, [])


    return (
        <>
            <Breadcrumb title="Dashboard" parent="" />
            <div className="container-fluid">
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header pb-0'>
                                <h5>Answered Calls</h5>
                            </div>
                            <div className='card-body'>
                                <InboundCallNotifications/>
                                
                            </div>

                        </div>
                    </div>
                </div>
                
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header pb-0'>
                                <h5>Answered Calls - Status Pending</h5>
                            </div>
                            <div className='card-body'>
                                <InCompletedcallLists />

                            </div>

                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header pb-0'>
                                <h5>Assigned Outbound Calls</h5>
                            </div>
                            <div className='card-body'>
                                <UserAssignedLists />

                            </div>

                        </div>
                    </div>
                </div>



                <div className='row justify-content-center'>

                </div>


            </div>
        </>
    )
}

export default Dashboard;